import { Box, Checkbox, Flex, Image, Text, Tooltip, useDisclosure } from '@chakra-ui/react';
import WalletHistoryPrice from 'components/Wallet/WalletHistoryPrice';
import AddToCartModal from 'pages/dashboard/components/AddToCartModal';
import { cartIcon, deleteIcon } from 'pages/dashboard/components/Icons';
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { remove_from_wishlist } from 'redux/actions/wishActions';

export default function WishlistBox({ item, updateItem }) {
    const dispatch = useDispatch();

    const {
        isOpen: isCartModalOpen,
        onClose: onCartModalClose,
        onOpen: onCartModalOpen,
    } = useDisclosure();

    const deleteFromList = () => {
        toast.promise(
            dispatch(remove_from_wishlist(item.item_id)),
            {
                loading: 'Removing...',
                success: <b> Item Removed</b>,
                error: <b>Could not remove item.</b>,
            },
            { position: 'top-right' },
        );
    };

    const addToCart = (item) => {
        onCartModalOpen();
    };
    const image = item?.image_Url ? JSON.parse(item?.image_Url) : [];
    return (
        <>
            <Flex
                border="0.724px solid rgba(0, 0, 0, 0.10)"
                p="3"
                flexDir="column"
                pos={'relative'}>
                <Flex alignItems="start" gap="2">
                    <Checkbox isChecked={item.isChecked} onChange={() => updateItem(item)} />
                    <Flex flexDir="column">
                        <Text color="#1b3b5f" fontSize="x-small">
                            {item.name}
                        </Text>
                    </Flex>
                </Flex>
                {/* {item?.available_stock <= 0 && (
                    <Box
                        pos={'absolute'}
                        top={0}
                        right={0}
                        px={1}
                        background={'red.500'}
                        textColor={'white'}
                        shadow={'dark-lg'}
                        fontSize={'xs'}>
                        Out Of Stock
                    </Box>
                )} */}
                <Flex p="5" gap="10">
                    <Flex justifyContent="space-between" flexDir="column">
                        <Flex flexDir="column">
                            {/* <Text fontSize="xx-small">Pack of 10 | Size 10</Text> */}
                            <Text fontSize="md" fontWeight="bold">
                                <WalletHistoryPrice price={item?.rate ?? 0} />
                            </Text>
                        </Flex>
                        <Flex gap="5">
                            <Tooltip
                                hasArrow
                                label="Add to cart"
                                bg="black"
                                color="white"
                                placement="bottom"
                                fontSize="xs"
                                arrowSize={7}>
                                <button
                                    // disabled={item?.available_stock <= 0}
                                    onClick={() => addToCart(item)}>
                                    {cartIcon}
                                </button>
                            </Tooltip>
                            <Box border="1px solid black" opacity="0.2" />
                            <Tooltip
                                hasArrow
                                label="Delete"
                                bg="black"
                                color="white"
                                placement="right"
                                fontSize="xs"
                                arrowSize={7}>
                                <p onClick={deleteFromList}>{deleteIcon}</p>
                            </Tooltip>
                        </Flex>
                    </Flex>
                    <Flex>
                        <Image src={image?.[0]} />
                    </Flex>
                </Flex>
            </Flex>
            <AddToCartModal
                isModalOpen={isCartModalOpen}
                closeModal={onCartModalClose}
                setIsModalOpen={onCartModalOpen}
                currentItem={item}
            />
        </>
    );
}
